import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-active-be-expert-dialog-box',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './active-be-expert-dialog-box.component.html',
	styleUrl: './active-be-expert-dialog-box.component.scss'

})
export class ActiveBeExpertDialogBoxComponent {


	constructor(
		private dialogRef: MatDialogRef<ActiveBeExpertDialogBoxComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { isVisible: boolean }
	) { }


	close() {
		this.dialogRef.close(null);
	}

	confirmVisibilityChange(value: boolean) {
		this.dialogRef.close(value);
	}
}